import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetProductParams, ProductGet, ProductService } from '@app/services/product.service';

@Component({
    selector: 'tt-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetProductParams;

    public get?: ProductGet;

    @HostBinding('class.tt-label-on-top')
    public labelOnTop = true;

    constructor(
        private product: ProductService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.product.getProduct(this.params);
            this.cdr.markForCheck();
        }
    }

    private async init() {
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.page_heading ?? '');
        this.cdr.markForCheck();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }
}
